import type { ApiRequestOptions } from '../../../../openapi/core/ApiRequestOptions'
import { store } from '../../../../store'

/**
 * Headers resolver for OpenAPI requests.
 *
 * Reads the access token from Redux memory (the source of truth after the move to
 * HttpOnly cookies). Adds `X-Client-Type: web` so the server returns refresh tokens
 * via cookie instead of body.
 */
export const headersResolver = async (
  options: ApiRequestOptions
): Promise<Record<string, string>> => {
  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
    'User-Agent': 'BirdBrain-Admin/1.0',
    'X-Client-Type': 'web',
  }

  const token = store.getState().authenticationView.accessToken
  if (token) {
    headers['Authorization'] = `Bearer ${token}`
  }

  if (options.mediaType && options.mediaType !== 'application/json') {
    headers['Content-Type'] = options.mediaType
  }

  return headers
}
